import { ApiProductStatus, ProductAlias, ProductStatus } from '@ibk/shared-types';
export function mapApiStatusToUIStatus(productAlias, apiStatus) {
    if (productAlias === ProductAlias.COBRANCAS) {
        switch (apiStatus) {
            case ApiProductStatus.AVAILABLE:
                return ProductStatus.ACTIVATE;
            case ApiProductStatus.ACTIVE:
                return ProductStatus.ACTIVE;
            case ApiProductStatus.ACTIVATING:
            case ApiProductStatus.NOT_APPROVED:
            default:
                return ProductStatus.ACTIVATE;
        }
    }
    if (productAlias === ProductAlias.CONTA_DIGITAL) {
        switch (apiStatus) {
            case ApiProductStatus.ACTIVE:
                return ProductStatus.CONTRACTED;
            case ApiProductStatus.ACTIVATING:
                return ProductStatus.ANALYSIS;
            case ApiProductStatus.NOT_APPROVED:
                return ProductStatus.NOT_APPROVED;
            case ApiProductStatus.AVAILABLE:
            case ApiProductStatus.DEACTIVATED:
            default:
                return ProductStatus.NOT_CONTRACTED;
        }
    }
    switch (apiStatus) {
        case ApiProductStatus.AVAILABLE:
            return ProductStatus.NOT_CONTRACTED;
        case ApiProductStatus.ACTIVE:
            return ProductStatus.CONTRACTED;
        case ApiProductStatus.ACTIVATING:
        case ApiProductStatus.NOT_APPROVED:
        default:
            return ProductStatus.NOT_CONTRACTED;
    }
}
